<template>
    <div></div>
</template>

<script>
export default {
  mounted() {
    console.log('anchor mounted111');
    this.scrollToAnchor();
  },
  methods: {
    scrollToAnchor() {
      const hash = window.location.hash;
      console.log('hash = '  + hash);
      if (hash) {
        const target = document.querySelector(hash);
        const targetOffsetTop = window.pageYOffset + target.getBoundingClientRect().top;
        //console.log(targetOffsetTop);

        if (target) {
          window.scrollTo({
            top: targetOffsetTop,
            behavior: 'smooth'
          });
        }
      }
    }
  }
}
</script>
